import type { SVGProps } from 'react';
import * as React from 'react';

const UsersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/users">
      <g id="Icon">
        <path
          d="M8.39998 9.60039C10.3882 9.60039 12 7.98862 12 6.00039C12 4.01217 10.3882 2.40039 8.39998 2.40039C6.41175 2.40039 4.79998 4.01217 4.79998 6.00039C4.79998 7.98862 6.41175 9.60039 8.39998 9.60039Z"
          fill="currentColor"
        />
        <path
          d="M17.4 10.8004C19.0568 10.8004 20.4 9.45725 20.4 7.80039C20.4 6.14354 19.0568 4.80039 17.4 4.80039C15.7431 4.80039 14.4 6.14354 14.4 7.80039C14.4 9.45725 15.7431 10.8004 17.4 10.8004Z"
          fill="currentColor"
        />
        <path
          d="M1.93831 19.714C1.46155 19.4087 1.18539 18.8656 1.25524 18.3039C1.69696 14.7508 4.7273 12.0004 8.39986 12.0004C12.0724 12.0004 15.1027 14.7501 15.5445 18.303C15.6143 18.8648 15.3382 19.4078 14.8614 19.7131C12.9962 20.9074 10.7789 21.6004 8.39986 21.6004C6.02082 21.6004 3.80348 20.9081 1.93831 19.714Z"
          fill="currentColor"
        />
        <path
          d="M17.4 19.2004C17.3577 19.2004 17.3154 19.2001 17.2731 19.1995C17.3557 18.8434 17.3786 18.4666 17.3307 18.0809C17.1202 16.3879 16.4401 14.8408 15.4248 13.5744C16.0375 13.333 16.7049 13.2004 17.4033 13.2004C19.731 13.2004 21.7148 14.6732 22.4735 16.7377C22.6365 17.1815 22.4454 17.6693 22.0405 17.9134C20.6855 18.7304 19.0977 19.2004 17.4 19.2004Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default UsersIcon;
